var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"17","height":"13","viewBox":"0 0 17 13","fill":"none"}},[_c('path',{attrs:{"d":"M0 0V0.48H16.8V0H0ZM0 6.24V6.72H16.8V6.24H0ZM0 12.48V12.96H16.8V12.48H0Z","fill":"black"}})])}
var staticRenderFns = []

export { render, staticRenderFns }